export default __webpack_public_path__ + "static/media/ic_con_address.35a7af4a.svg";